<template>
  <div :class="isQs===1?'avatar_out_box_sq':'avatar_out_box'">
    <el-avatar :size="isQs===1?50:100" :shape="isQs===1?'square':'circle'" :src="imgUrl"/>
    {{ option.img }}
    <ElUpload
        class="upload-demo"
        :on-change="changeSize"
        :show-file-list="false"
        :on-error="handleUploadError"
        :on-success="handleUploadSuccess"
        :auto-upload="false"
        accept=".jpg,.png"
        action=""
    >
      <!--      :action="action"-->
      <!--      :headers="{-->
      <!--      'X-Access-Token': getToken(),-->
      <!--      }"-->
      <template #trigger>
        <div class="edits">{{ $t('common.edit') }}</div>
      </template>
    </ElUpload>

    <!-- 头像裁剪弹窗 -->
    <el-dialog
        v-model="centerDialogVisible"
        title="裁剪头像"
        width="60%"
        align-center
    >
      <div class="cropper-content">
        <div
            class="cropper"
            style="text-align:center"
        >
          <vueCropper
              ref="cropper"
              :img="option.img"
              :outputSize="option.size"
              :outputType="option.outputType"
              :info="true"
              :full="option.full"
              :canMove="option.canMove"
              :canMoveBox="option.canMoveBox"
              :original="option.original"
              :autoCrop="option.autoCrop"
              :fixed="option.fixed"
              :fixedNumber="option.fixedNumber"
              :centerBox="option.centerBox"
              :infoTrue="option.infoTrue"
              :fixedBox="option.fixedBox"
              :autoCropWidth="option.autoCropWidth"
              :autoCropHeight="option.autoCropHeight"
          />
          <div class="handle_btn">
            <el-button
                type="primary"
                plain
                @click="changeScale(1)"
            >+ 放大
            </el-button>
            <el-button
                type="primary"
                plain
                @click="changeScale(-1)"
            >- 缩小
            </el-button>
            <el-button
                type="primary"
                plain
                @click="rotateLeft"
            >↺ 左旋转
            </el-button>
            <el-button
                type="primary"
                plain
                @click="rotateRight"
            >↻ 右旋转
            </el-button>
          </div>

        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取消</el-button>
          <el-button
              type="primary"
              @click="uploadAvatar"
              :loading="isLoading"
          > 确认 </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import {ref, defineEmits, reactive, watch} from "vue";
import {getToken} from "@/utils/auth";
import axios from "axios";
import {ElMessage} from "element-plus";
// 在页面引入
import "vue-cropper/dist/index.css";
import {VueCropper} from "vue-cropper";

const emits = defineEmits(['update:modelValue'])
const multipartFiles = ref([])
const props = defineProps({
  isQs: {
    type: Number,
    default: 0
  },
  imgUrl: {
    type: String,
    default: ''
  }
});

// 头像裁剪
const centerDialogVisible = ref(false);
//获取裁剪图片组件
const cropper = ref();
// 头像裁剪各项参数
const option = reactive({
  img: "", // 裁剪图片的地址
  info: true, // 裁剪框的大小信息
  outputSize: 1, // 裁剪生成图片的质量
  outputType: "jpg", // 裁剪生成图片的格式
  canScale: true, // 图片是否允许滚轮缩放
  autoCrop: true, // 是否默认生成截图框
  canMoveBox: true, // 截图框能否拖动
  autoCropWidth: 200, // 默认生成截图框宽度
  autoCropHeight: 200, // 默认生成截图框高度
  fixedBox: false, // 固定截图框大小 不允许改变
  fixed: true, // 是否开启截图框宽高固定比例
  fixedNumber: [1, 1], // 截图框的宽高比例
  full: false, // 是否输出原图比例的截图
  original: false, // 上传图片按照原始比例渲染
  centerBox: false, // 截图框是否被限制在图片里面
  infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
});

// 上传的地址
const action = ref(`${process.env.VUE_APP_BASE_API}/sys/oss/qiniu/upload`);
const circleUrl = ref('')

function handleUploadError(error) {
  try {
    const status = error?.response?.status;
    if (status === 413) {
      ElMessage.error('上传失败：文件过大，请压缩后重试或更换更小的文件。');
      return;
    }
  } catch (e) {
  }
  ElMessage.error('上传失败，请稍后重试');
}

const successAvatarUrl = ref("")

function handleUploadSuccess() {
//   将数据进行回传？
  if (successAvatarUrl.value !== "") {
    emits("update:modelValue", successAvatarUrl.value)
  }
}


const changeSize = (UploadFile) => {
  console.log(UploadFile, 'UploadFile')
  centerDialogVisible.value = true;
  //这里将图片转化为base64位格式为图片进行裁剪
  const reader = new FileReader();
  reader.onload = (e) => {
    //将图片绑定到裁剪组件的img中
    option.img = e.target.result;
  };
  //拿到图片的base64
  reader.readAsDataURL(UploadFile.raw);
};

//图片缩放
const changeScale = (num) => {
  num = num || 1;
  cropper.value.changeScale(num);
};
//向左旋转
const rotateLeft = () => {
  cropper.value.rotateLeft();
};
//向右旋转
const rotateRight = () => {
  cropper.value.rotateRight();
};


// 点击确认
const isLoading = ref(false)
const uploadAvatar = () => {
  isLoading.value = true;
  //上传头像并且点击了确认按钮 异步才能获取数据
  cropper.value.getCropBlob(async (data) => {
    let formData = new FormData();
    formData.append("file", data, "avatar.jpg");
    try {
      const res = await axios({
        method: "post",
        headers: {
          'X-Access-Token': getToken(),
        }, // 请求头
        url: action.value, //请求地址
        data: formData,
      });
      console.log(res, '=====res,')
      if (res.status === 200) {
        if (res.data.code === 200) {
          isLoading.value = false;
          successAvatarUrl.value = res.data.result.url
          handleUploadSuccess()
          centerDialogVisible.value = false
        } else {
          isLoading.value = false;
          successAvatarUrl.value = ""
          handleUploadError(res)
          centerDialogVisible.value = false
        }
      } else {
        handleUploadError(res)
        centerDialogVisible.value = false
      }
    } catch (e) {
      isLoading.value = false;
      successAvatarUrl.value = ""
      handleUploadError(e)
      centerDialogVisible.value = false
    }
  });
};
</script>

<style lang="less" scoped>
.avatar-box-border {
  border: 1px dashed #409eff !important;
}

.avatar_out_box {
  position: relative;
  display: flex;
  width: 100px;
  height: 100px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  overflow: hidden;

}

.avatar_out_box_sq {
  position: relative;
  display: flex;
  width: 100px;
  height: 100px;
  border-radius: 4px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

:deep(.el-avatar--square >img) {
  height: 60px !important;
  width: 60px !important;
}

:deep(.el-avatar) {
  position: absolute;
}

.edits {
  width: 100px;
  text-align: center;
  line-height: initial;
  background: #3171f6;
  font-size: 14px;
  color: white;
  position: absolute;
  top: 80px;
}

.avatar_out_box {
  background: #f3f3f3 !important;
}

.cropper-content {
  .cropper {
    width: auto;
    height: 350px;

    .handle_btn {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      padding: 10px 300px;
      box-sizing: border-box;
    }
  }
}

:deep(.el-dialog__footer) {
  padding-top: 45px !important;
}
</style>
